import { Chip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";
import React, { Component } from "react";
// open source
import { TwitterPicker } from "react-color";
// styles
import styles from "./styles";

class FormCategory extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    category: PropTypes.object,

    createCpfmCategory: PropTypes.func,
    updateCpfmCategory: PropTypes.func,
    deleteCpfmCategory: PropTypes.func,
    refresh: PropTypes.func,

    subCategories: PropTypes.func,
    getCategorySubCategories: PropTypes.func,
    createCategorySubCategory: PropTypes.func,
    deleteCategorySubCategory: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = this.getInitState();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      nextProps.category && this.init(nextProps.category);
    }
  }

  init(category) {
    this.setState({
      loading: false,
      title: category ? category.title : "",
      description: category ? category.description : "",
      color: category ? category.color : "",
      icon: category ? category.icon : "",
      subCategoryInput: "",
    });
    this.getCategorySubCategories(category);
  }

  getInitState() {
    return {
      loading: false,
      color: undefined,
      title: "",
      icon: "",
      description: "",
      subCategoryInput: "",
      categorySubCategories: [],
    };
  }

  close() {
    const { close } = this.props;
    this.setState(this.getInitState());
    close();
  }

  handleTextChange = (name) => (event) => {
    const value = event.target.value;

    this.setState({
      [name]: value,
    });
  };

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: `Are you sure ?`,
        subtitle:
          "If you delete this category, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteCpfmCategory, refresh, category } = this.props;

    const { NotificationCenter } = this.context;
    const resp = await deleteCpfmCategory(category.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Category has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
    this.close();
  }

  async save() {
    const {
      updateCpfmCategory,
      createCpfmCategory,
      category,
      refresh,
    } = this.props;

    const { title, description, cover, color, icon } = this.state;

    const { NotificationCenter } = this.context;

    let resp = undefined;
    this.setState({ loading: true });

    if (category) {
      resp = await updateCpfmCategory(category.id, {
        title,
        cover,
        icon,
        description,
        color: color && color.hex ? color.hex : color,
      });
    } else {
      resp = await createCpfmCategory({
        title,
        cover,
        icon,
        description,
        color: color && color.hex ? color.hex : undefined,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: category
          ? "Category has been updated."
          : "Category has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      refresh();
      setTimeout(NotificationCenter.hide, 1500);
      this.close();
    }
  }

  async addCategorySubCategory(v) {
    const { category, createCategorySubCategory } = this.props;
    const r = await createCategorySubCategory({
      categoryID: category.id,
      subCategoryID: v.id,
    });
    if (r.success) {
      this.getCategorySubCategories(category);
    }
  }

  async deleteCategorySubCategory(csc) {
    const { deleteCategorySubCategory, category } = this.props;
    const r = await deleteCategorySubCategory(csc.id);
    if (r.success) {
      this.getCategorySubCategories(category);
    }
  }

  async getCategorySubCategories(category) {
    const { getCategorySubCategories, subCategories } = this.props;
    const r = await getCategorySubCategories([
      {
        name: "categoryID",
        comparison: "eq",
        value: category.id,
      },
    ]);
    if (r.payload) {
      const categorySubCategories = r.payload;

      for (const key in categorySubCategories) {
        if (categorySubCategories.hasOwnProperty(key)) {
          const element = categorySubCategories[key];
          element.subCategory = subCategories.find(
            (sc) => sc.id === element.subCategoryID
          );
        }
      }
      this.setState({
        categorySubCategories,
      });
    }
  }

  render() {
    const { classes, fullScreen, open, category, subCategories } = this.props;

    const {
      title,
      description,
      loading,
      cover,
      color,
      subCategoryInput,
      categorySubCategories,
      icon,
    } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {category ? `${category.title}` : "Let's Create a New Category"}
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="title"
                    variant="filled"
                    label="Title"
                    className={classes.textField}
                    value={title}
                    onChange={this.handleTextChange("title")}
                  />
                </Grid>
                <Grid xs={12}>
                  <div style={{ marginLeft: 10 }}>
                    <TwitterPicker
                      color={color}
                      triangle="hide"
                      onChangeComplete={(color) => this.setState({ color })}
                    />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="outlined-textarea"
                    label="Description"
                    placeholder="Description"
                    multiline
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    value={description}
                    onChange={this.handleTextChange("description")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="outlined-textarea"
                    label="Icon URL"
                    placeholder="Icon"
                    multiline
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    value={icon}
                    onChange={this.handleTextChange("icon")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    onChange={(e, v) => {
                      if (v) {
                        this.addCategorySubCategory(v);
                        setTimeout(
                          () => this.setState({ subCategoryInput: "" }),
                          100
                        );
                      }
                    }}
                    value={undefined}
                    inputValue={subCategoryInput}
                    onInputChange={(event, newInputValue) => {
                      this.setState({ subCategoryInput: newInputValue });
                    }}
                    options={subCategories}
                    getOptionLabel={(option) => option.title}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth label="Sub Categories" />
                    )}
                  />
                </Grid>
                <Grid item>
                  <Grid container>
                    {categorySubCategories &&
                      categorySubCategories.map((csc) => (
                        <Chip
                          label={
                            csc.subCategory ? csc.subCategory.title : "Untitled"
                          }
                          onDelete={() => this.deleteCategorySubCategory(csc)}
                        />
                      ))}
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {category ? (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} /> Delete
                </Button>
              ) : (
                []
              )}
              <Button onClick={this.close.bind(this)}>
                <CloseIcon className={classes.leftIcon} /> Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />{" "}
                {category ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormCategory));
